import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_SHOULDERS_02: ReviewedLibraryIdentity[] = [
  {
    "id": "library-fanjue-external-rotation-press",
    "name": "仰卧哑铃外旋位推举",
    "group": "shoulders",
    "subCategory": "front-deltoid",
    "equipment": "dumbbell",
    "pattern": "仰卧外旋位推举",
    "legacyIds": [
      "fanjue-external-rotation-press"
    ],
    "sourceId": "course-20261008-fanjue-plan-07-05",
    "targetMuscles": [
      "三角肌前束",
      "肩袖肌群"
    ],
    "evidence": "主线程抽帧可见仰卧地面小哑铃推举；清单为正式，不属于训练前激活"
  },
  {
    "id": "library-fanjue-rear-delt-bodyweight",
    "name": "单臂坐姿哑铃后束飞鸟",
    "group": "shoulders",
    "subCategory": "rear-deltoid",
    "equipment": "dumbbell",
    "pattern": "坐姿单臂肩水平外展",
    "legacyIds": [
      "fanjue-rear-delt-bodyweight"
    ],
    "sourceId": "course-20261008-fanjue-plan-07-04",
    "targetMuscles": [
      "三角肌后束",
      "斜方肌中下部"
    ],
    "evidence": "主线程帧核对单臂支撑位，与双哑铃坐姿飞鸟保留变式差异"
  },
  {
    "id": "library-fanjue-supine-face-pull",
    "name": "仰卧绳索面拉",
    "group": "shoulders",
    "subCategory": "rear-deltoid",
    "equipment": "cable",
    "pattern": "仰卧水平拉及肩外旋",
    "legacyIds": [
      "fanjue-supine-face-pull"
    ],
    "sourceId": "course-20261008-fanjue-plan-10-03",
    "targetMuscles": [
      "三角肌后束",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-standing-military-press",
    "name": "站姿杠铃推举",
    "group": "shoulders",
    "subCategory": "front-deltoid",
    "equipment": "barbell",
    "pattern": "站姿自由杠铃垂直推",
    "legacyIds": [
      "fanjue-standing-military-press"
    ],
    "sourceId": "course-20261008-four-way-04-04",
    "targetMuscles": [
      "三角肌前束",
      "三角肌中束",
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-dumbbell-front-raise",
    "name": "双哑铃前平举",
    "group": "shoulders",
    "subCategory": "front-deltoid",
    "equipment": "dumbbell",
    "pattern": "双哑铃肩屈",
    "legacyIds": [
      "fanjue-dumbbell-front-raise"
    ],
    "sourceId": "course-20261008-home-04-04",
    "targetMuscles": [
      "三角肌前束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
